<style lang="less">
html,
body {
  height: auto;
}
</style>

<style lang="less" scoped>
* {
  margin: 0;
}

.container-water-fall {
  // padding: 0 28px;
  width: 100vw;
  box-sizing: border-box;

  h4 {
    padding-top: 56px;
    padding-bottom: 28px;
    font-family: PingFangSC-Medium;
    font-size: 36px;
    color: #000000;
    letter-spacing: 1px;
    text-align: justify;
  }

  button {
    background-color: #ff0;
    color: #24292e;
    border: 1px solid rgba(27, 31, 35, 0.2);
    border-radius: 0.25em;
    width: 100px;
    line-height: 26px;
    font-size: 13px;
    margin: 4px 0;
    margin-right: 4px;
    cursor: pointer;
    outline: none;

    &.blue-light {
      background: #27fbc2;
    }
  }

  button:hover {
    background-image: linear-gradient(-180deg, #fafbfc, #ccc 90%);
  }

  .ck {
    float: right;
    position: relative;
    bottom: 30px;
    right: 10px;
    height: 0px;
  }

  .addBtn {
    position: fixed;
    bottom: 60px;
    right: 15px;
    width: 56px;
    height: 56px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 0 4px #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    color: #24a378;
    float: right;
    z-index: 100;
  }

  .cell-item {
    width: 100%;
    // margin-bottom: 18px;
    background: #ffffff;
    border: 2px solid #f0f0f0;
    border-radius: 12px 12px 12px 12px;
    overflow: hidden;
    box-sizing: border-box;

    img {
      // border-radius: 12px 12px 0 0;
      width: 100%;
      height: auto;
      display: block;
    }

    .item-body {
      // border: 1px solid #F0F0F0;
      padding: 12px;

      .item-desc {
        font-size: 15px;
        color: #333333;
        line-height: 15px;
        font-weight: bold;
      }

      .item-footer {
        margin-top: 22px;
        position: relative;
        display: flex;
        align-items: center;

        .avatar {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background-repeat: no-repeat;
          background-size: contain;
        }

        .name {
          max-width: 150px;
          margin-left: 10px;
          font-size: 14px;
          color: #999999;
        }

        .like {
          position: absolute;
          right: 0;
          display: flex;
          align-items: center;

          &.active {
            i {}

            .like-total {
              color: #ff4479;
            }
          }

          i {
            width: 28px;
            display: block;
          }

          .like-total {
            margin-left: 10px;
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
  }
}

.githubdata {
  float: right;
  margin-right: 90px;

  img {
    width: 14px;
    // height: 16px;
  }
}
</style>
<template>
  <div class="container-water-fall">
    <waterfall :col="col" :data="data" @loadmore="loadmore">
      <template>
        <div class="cell-item" v-for="(item, index) in data" :key="index">
          <img v-if="item.ImageImgPath" :lazy-src="item.ImageImgPath" alt="加载错误" @click="preview(index)" />
          <!--  <div class="item-body">
            <div class="item-desc">{{item.title}}</div>
            <div class="item-footer">
              <div
                v-if="item.avatar"
                class="avatar"
                :style="{backgroundImage : `url(${item.avatar})` }"
              ></div>
              <div class="name">{{item.user}}</div>
              <div class="like" :class="item.liked?'active':''">
                <i></i>
                <div class="like-total">{{item.like}}</div>
              </div>
            </div>
          </div> -->
          <div v-if="isShow" class="ck">
            <input ref="ckbox" type="checkbox" :value="item.GID" />
          </div>
        </div>
      </template>
    </waterfall>

    <loading :show="loading" />
    <div v-if="isShow" class="addBtn" @click="delimage">
      <van-icon name="delete" />
    </div>
  </div>
</template>

<script>
/*
  注意:
  1.itemWidth需要与gutterWidth一起使用才会生效，否则会进行自适应宽度
  2.使用了waterfall的组件不允许使用scoped,否则样式会有问题
*/
import loading from "./loading";
import { ImagePreview, Toast, Dialog } from "vant";
export default {
  props: {
    title: String,
  },
  components: {
    loading,
  },
  props: {
    gid: {
      // 相册组id
      type: String,
    },
    isShow: {
      // 页面show
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      col: 2,
      loading: false,
      finished: false,
      gitHubData: {},
      originData: [],
    };
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    },
  },
  methods: {
    scroll(scrollData) {
      console.log(scrollData);
    },
    loadmore() {
      // console.log("zzzzzzzzzzzzzzzzzzzz");
      if (!this.finished) {
        this.loading = true;
        // setTimeout(() => {
        //   this.data = this.data.concat(this.originData, this.originData);
        //   this.loading = false;
        // }, 1000);
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1,
        });
        this.getList();
      }
    },
    preview(index) {
      if (this.isShow) {
        this.$refs.ckbox[index].checked = !this.$refs.ckbox[index].checked;
      } else {
        ImagePreview({
          // images: this.originData.map(item => (item.img || item.url)),
          images: this.data.map(
            (item) => item.ImageImgPath || item.ImageImgPath
          ),
          startPosition: index,
          closeable: true,
        });
      }
    },
    init() {
      var that = this;
      that.options = {
        type: "GetImageImageSearchList",
        id: this.gid,
        pageIndex: 1,
        PageRows:20
      };
      that.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        (res) => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.ImgInfoApiModelList;
          if (dataList.length <= 0) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach((element) => {
                that.data.push(element);
              });
            }
          } else {
            that.data = dataList;
          }
        },
        (error) => { }
      );
    },
    delimage() {
      var that = this;
      Dialog.confirm({
        message: "确定删除这些图片吗？",
      }).then(
        () => {
          var params = {
            type: "ImageImagesDelectVue",
            Gid: that.gid,
            Gids: [],
          };
          that.$refs.ckbox.map((e) => {
            if (e.checked) {
              params.Gids.push(e.value);
            }
          });
          if (params.Gids.length == 0) {
            Toast("至少选中一张图片");
            return;
          } else {
            that.$store.dispatch(params).then(
              (res) => {
                if (res.IsSuccess) {
                  that.$router.go(0);
                  Toast(res.Message);
                } else {
                  Toast(res.Message);
                }
              },
              (err) => { }
            );
          }
        },
        () => { }
      );
    },
  },
  mounted() {
    //this.data = this.originData;
  },
  created() {
    var that = this;
    that.init();
  },
};
</script>
